import { Phone, MessageSquare, Mail } from "lucide-react";
import { digits } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";
import { TextTemplates } from "./TextTemplates";

const actionCls = (primary) => `flex h-16 flex-1 flex-col items-center justify-center gap-0.5 rounded-2xl text-sm font-bold transition-transform active:scale-[0.97] ${
  primary ? "bg-[color:var(--brand)] text-white" : "border-2 border-border bg-card text-foreground"}`;

export const ContactActions = ({ contact, serviceType }) => {
  const { user } = useAuth();
  const tel = `+1${digits(contact.phone).slice(-10)}`;
  const subject = encodeURIComponent(`Your ${serviceType} project`);
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-border bg-card/90 backdrop-blur-xl lg:left-64"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="lead-contact-actions">
      <div className="mx-auto flex max-w-5xl gap-2 px-4 py-3">
        <a href={`tel:${tel}`} className={actionCls(true)} data-testid="lead-call-button"><Phone className="h-6 w-6" /> Call</a>
        <TextTemplates tel={tel} contact={contact} serviceType={serviceType} companyName={user.company_name}
          trigger={<button type="button" className={actionCls(false)} data-testid="lead-text-button"><MessageSquare className="h-6 w-6" /> Text</button>} />
        <a href={`mailto:${contact.email}?subject=${subject}`} className={actionCls(false)} data-testid="lead-email-button"><Mail className="h-6 w-6" /> Email</a>
      </div>
    </div>
  );
};
